import { action } from 'easy-peasy';
import { IActionResetCurrentClient } from '../types';

const resetCurrentClient: IActionResetCurrentClient = action(state => {
  state.current = null;
});

export default resetCurrentClient;
